module.exports = __webpack_public_path__ + "static/media/church-of-england.5ddbb03f.svg";